import { IMessage } from "../schemas/entity_set";
import { IModelService, IModelQuery, IRequestResult } from "../schemas/structure"

interface IMessageFilter extends IModelQuery {
    date: Date;
    memberId: number;
}

interface IMessageService extends IModelService<IMessage> {
    query(params: IMessageFilter): angular.IPromise<IRequestResult<Array<IMessage>>>
    sendMessage(message: IMessage): angular.IPromise<IRequestResult<IMessage>>
    resend(id: number): angular.IPromise<IRequestResult<IMessage>>
    sendBulkMessage(message: IMessage): angular.IPromise<IRequestResult<IMessage>>
}

class MessageService implements IMessageService {

    static $inject = ["$q", "$http", "BASEAPI"];

    constructor(private $q: angular.IQService,
        private $http: angular.IHttpService,
        private baseUrl: string) { }

    get() {
        let defer = this.$q.defer<IRequestResult<IMessage[]>>()
        this.$http.get(`${this.baseUrl}/message`).then((response: IRequestResult<Array<IMessage>>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    find(id: number) {
        let defer = this.$q.defer<IRequestResult<IMessage>>()
        this.$http.get(`${this.baseUrl}/message?id=${id}`).then((response: IRequestResult<IMessage>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    sendMessage(message: IMessage) {
        let defer = this.$q.defer<IRequestResult<IMessage>>()
        this.$http.post(`${this.baseUrl}/v1/messaging/sendmessage`, message).then((response: IRequestResult<IMessage>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    resend(id: number) {
        let defer = this.$q.defer<IRequestResult<IMessage>>()
        this.$http.get(`${this.baseUrl}/v1/messaging/resend?id=${id}`).then((response: IRequestResult<IMessage>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    sendBulkMessage(message: IMessage) {
        let defer = this.$q.defer<IRequestResult<IMessage>>()
        this.$http.post(`${this.baseUrl}/v1/messaging/sendbulkmessage`, message).then((response: IRequestResult<IMessage>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    query(params: IMessageFilter) {
        let defer = this.$q.defer<IRequestResult<IMessage[]>>()
        this.$http.post(`${this.baseUrl}/message/query`, params).then((response: IRequestResult<Array<IMessage>>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

    save(message: IMessage) {
        let defer = this.$q.defer<IRequestResult<IMessage>>()
        if (message.id) {
            this.$http.put(`${this.baseUrl}/message`, message).then((response: IRequestResult<IMessage>) => {
                defer.resolve(response)
            })
        } else {
            this.$http.post(`${this.baseUrl}/message`, message).then((response: IRequestResult<IMessage>) => {
                defer.resolve(response)
            })
        }
        return defer.promise
    }

    delete(id: number) {
        let defer = this.$q.defer<IRequestResult<IMessage>>()
        this.$http.delete(`${this.baseUrl}/message?id=${id}`).then((response: IRequestResult<IMessage>) => {
            defer.resolve(response)
        })
        return defer.promise
    }

}

export { MessageService, IMessageService, IMessageFilter }


// WEBPACK FOOTER //
// ./app/messenger/message_service.ts